var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#phone';
                    var viewUrl = 'svg/icons.svg#view-phone';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };